export default __webpack_public_path__ + "static/media/undraw_auth.79ea55c5.svg";